import { render, staticRenderFns } from "./mostPlayed.vue?vue&type=template&id=3d694a37&"
import script from "./mostPlayed.vue?vue&type=script&lang=js&"
export * from "./mostPlayed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports